import { generateSectionSchema } from "../../../libraries/ReportGenerator/SchemaHelpers/SchemaHelpers";
import { generateIdFieldNamePairs } from "../../../libraries/ReportGenerator/SchemaHelpers/SchemaHelpers";
const RailRoadSectionCols = ["RR/Co Initial", "Railroad/Company Name", "Division", "Subdivision", "Inspection Point"];
const InspectionSectionCols = [
  "Inspector Name",
  "Inspector Viol No",
  "Annual F6180 96No",
  "Inspection Date",
  "Violation Date",
  "Violation Rpt. Date",
];

const colSpanTotal = 20;
const headerConfig = { headerOnly: true, colSpan: colSpanTotal, headerSize: "40px" };
const configInline = { inlineData: true, topAlign: true, colSpan: colSpanTotal, headerSize: "80px" };
const additionalConfig = { valueOnNextLine: true, unBold: true };
const configInlineHeaderSize = { inlineData: true, topAlign: true, colSpan: colSpanTotal, headerSize: "90px" };
let insecptorSectionSchema = generateSectionSchema(InspectionSectionCols, configInline);
let railroadInfoSectionHeader = generateSectionSchema(["RAILROAD INFORMATION"], headerConfig);
let railroadInfoSection = generateSectionSchema(RailRoadSectionCols, configInline);
let itemsViolatedHeader = generateSectionSchema(["ITEM(S) VIOLATED"], headerConfig);
let itemsViolatedRow1 = generateSectionSchema(
  ["Track Type", "Track Name/No", "Initials/Milepost", "Speed", "Track Class", "MGT", "HazMat", "Method of Operation"],
  configInline,
);
let itemsViolatedRow2 = generateSectionSchema(
  ["Line Item", "Part No", "Part Title", "Sect. No", "Section Title", "Paragraph/Code", "Counts"],
  configInline,
);
let itemsViolatedRow3 = generateSectionSchema(["Text of Violated Paragraphs"], configInlineHeaderSize);
let NarrativeHeader = generateSectionSchema(["NARRATIVE"], headerConfig);
let NarrativeR1 = generateSectionSchema(["Synopsis of Violation"], configInlineHeaderSize);
let NarrativeR2 = generateSectionSchema(["Geographic Condition/Description"], configInlineHeaderSize);
let NarrativeR3 = generateSectionSchema(["Seriousness/Reasons for Violation"], configInlineHeaderSize);
let NarrativeR4 = generateSectionSchema(["Prior or Constructive Knowledge"], configInlineHeaderSize);
let NarrativeR5 = generateSectionSchema(["Other Items Found During Inspection (not recommended for violation)"], configInlineHeaderSize);
let NarrativeR6 = generateSectionSchema(["Background/Special Circumstances"], configInlineHeaderSize);
let NarrativeR7 = generateSectionSchema(["Attachment List"], configInlineHeaderSize);

let FooterHeader = generateSectionSchema(["FRA INSPECTOR SIGNATURE", "RAILROAD/COMPANY REPRESENTATIVE"], headerConfig);
let FooterR1 = generateSectionSchema(["FRA Inspector Signature", "Date Signed", "Name", "Title"], configInline);
let FooterR2 = generateSectionSchema(["FRA Inspector No. 2", "Accompanied FRA Inspector During Inspection"], configInline);

export const sampleASchema = {
  sections: [
    insecptorSectionSchema,
    railroadInfoSectionHeader,
    railroadInfoSection,
    itemsViolatedHeader,
    itemsViolatedRow1,
    itemsViolatedRow2,
    itemsViolatedRow3,
    NarrativeHeader,
    NarrativeR1,
    NarrativeR2,
    NarrativeR3,
    NarrativeR4,
    NarrativeR5,
    NarrativeR6,
    NarrativeR7,
    FooterHeader,
    FooterR1,
    FooterR2,
  ],
};

const code = "trackViolationReportForm";
const desc = "Track Violation Report Form";
const opt2 = {
  viewGroup: "1",
  target: "task",
};

export const appForm = {
  code: code,
  tenantId: "ps19",
  description: desc,
  listName: "appForms",
  opt2: opt2,
  opt1: generateIdFieldNamePairs(sampleASchema),
};

// Use `railroadInfoSection` when rendering this specific section

const additionalConfigBlueCard = { valueOnNextLine: true };
const configInlineHeaderSizeBlueCard = { inlineData: true, topAlign: true, colSpan: colSpanTotal, headerSize: "80px" };

let row1 = generateSectionSchema(
  ["Year", "1. Operated by", "RR Code", "2. Owned by", "RR Code"],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row2 = generateSectionSchema(
  ["3. Model No", "4. Loco No.", "If renumbered. Prev No", "5. Year Built", "Check if new loco"],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row3 = generateSectionSchema(
  ["6. Propelled by", "7. Horse Power", "8. Type of Service", "9. Steam Gen. a. No", "b. Working Pressure", "10. Max. Piston Travel in."],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row4 = generateSectionSchema(
  ["Type of Air Brake", "Air Dryer", "11. Out of use Credit", "12. Last Periodic Inspection", "a. Date", "b. Place"],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row5 = generateSectionSchema(
  ["AFM CAL \n229.29(b)", "92 day max. interval", "Previous date", "Date & Cert:", "Date & Cert:", "Date & Cert:", "Date & Cert:"],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row6 = generateSectionSchema(
  ["Periodic Inspections", "Check one", "92 Days per 229.23(a)", "184 Days per 229.23(b)(1) only"],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row7 = generateSectionSchema(
  ["13. Date: Mo/Day/Yr", "14. Place", "15. Items*", "16. Person Conducting", "15. Items*", "16. Person Conducting", "17. Certified by "],
  { ...configInlineHeaderSize },
  additionalConfigBlueCard,
);

let row8 = generateSectionSchema(
  ["13. Date: Mo/Day/Yr", "14. Place", "15. Items*", "16. Person Conducting", "15. Items*", "16. Person Conducting", "17. Certified by "],
  configInlineHeaderSize,
  { ...additionalConfigBlueCard, isValueOnly: true, dontJoinValues: true },
);

let row9 = generateSectionSchema(
  [
    "15. Item Code\t\t\t\t1. Brakes\t\t\t\t2. Running Gear\t\t\t\t3. Cab Equip\t\t\t\t4. Mech Equip\t\t\t\t5. Elect Equip\t\t\t\t6. Steam Gen\t\t\t\t7. Safety Appl",
  ],
  configInlineHeaderSize,
  { ...additionalConfigBlueCard, isTitleOnly: true },
);

let row10 = generateSectionSchema(
  ["TESTS", "H&H Test Pressure", "19. Waiver Part 229", "20. Waiver-Other"],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row11 = generateSectionSchema(
  [
    "Type",
    "Interval Not more than",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row12 = generateSectionSchema(
  [
    "Event Recorder 229.25(d) or 229.27(c)",
    "No. of days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row13 = generateSectionSchema(
  [
    "Annual Tests 229.27",
    "368 days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row14 = generateSectionSchema(
  [
    "Hand Brake 232.105(c)",
    "368 days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row15 = generateSectionSchema(
  [
    "Air Brakes: Level 1 229.29(c)(1)",
    "368 days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row16 = generateSectionSchema(
  [
    "Level 2 229.29(c)(2)",
    "No. of days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row17 = generateSectionSchema(
  [
    "Level 3 229.29(c)(3)",
    "No. of days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);

let row18 = generateSectionSchema(
  [
    "Hammer and Hydro 229.31",
    "736 days",
    "21. Person Conducting",
    "22. Test Date & Place",
    "23. Certified by",
    "24. Previous Test Date & Place",
  ],
  configInlineHeaderSize,
  additionalConfigBlueCard,
);
let testRow = [];
for (let i = 1; i < 5; i++) {
  testRow.push(
    generateSectionSchema(
      [
        {
          title: `13. Date: Mo/Day/Yr${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 3, formatter: "(val) => periodicFormatter(val,true)" },
          accessor: [`periodic92Days.period${i}Date`, `periodic184Days.period${i}Date`],
        },
        {
          title: `14. Place${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 2, formatter: "(val) => periodicFormatter(val)" },
          accessor: [`periodic92Days.period${i}Place`, `periodic184Days.period${i}Place`],
        },
        {
          title: `15. Items*${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 3, formatter: "(val) => periodicFormatter(val)" },
          accessor: [`periodic92Days.period${i}FormData.items`, `periodic184Days.period${i}FormData.items`],
        },
        {
          title: `16. Person Conducting${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 3, formatter: "(val) => periodicFormatter(val)" },
          accessor: [`periodic92Days.period${i}Name`, `periodic184Days.period${i}Name`],
        },
        {
          title: `15. Items*${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 3, formatter: "(val) => periodicFormatter(val)" },
          accessor: [`periodic92Days.period${i}FormData1.items`, `periodic184Days.period${i}FormData1.items`],
        },
        {
          title: `16. Person Conducting${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 3, formatter: "(val) => periodicFormatter(val)" },
          accessor: [`periodic92Days.period${i}Name1`, `periodic184Days.period${i}Name1`],
        },
        {
          title: `17. Certified by${i}`,
          configs: { isValueOnly: true, dontJoinValues: true, colSpan: 3, formatter: `(val) => periodicCertifyFormatter(period${i})` },
          accessor: [`periodic92Days`, `periodic184Days`],
        },
      ],
      { ...configInlineHeaderSize },
    ),
  );
}

export const blueCardSchema = {
  // sections: [row1, row2, row3, row4, row5, row6, row7, row8, row9, row10, row11, row12, row13, row14, row15, row16, row17, row18],
  sections: testRow,
};



// WEBPACK FOOTER //
// ./src/components/Reports/SampleReport/SampleAschema.js